import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from '@core/services/storage.service';
import { AlertController } from '@ionic/angular';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoaderService } from './loader.service';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  protected url: string;
  constructor(
    protected _alert: AlertController,
    protected _http: HttpClient,
    protected _loader: LoaderService,
    protected _storage: StorageService,
  ) {
    this.getUrl();
  }
  get(url: string, showLoader: boolean = true, showLog = true, params?: any, headers?: HttpHeaders): Observable<any> {
    if (showLoader) {
      this._loader.show();
    }
    return this.buildHeaders(headers).pipe(
      mergeMap((headers: any) => this._http.get(this.url + url, { headers: headers.headers, params: params })),
      mergeMap(r => {
        if (showLoader) {
          this._loader.hide();
        }
        return of(r);
      }),
      catchError(e => {
        console.log('Error', e);
        if (showLoader) {
          this._loader.hide();
        }
        return throwError(e);
      }),
    );
  }
  post(url: string, payload: any, showLoader: boolean = true): Observable<any> {
    if (showLoader) {
      this._loader.show();
    }
    console.log(`POST (${showLoader}): ${this.url}${url}`);
    return this.buildHeaders().pipe(
      mergeMap(header => this._http.post(this.url + url, payload, header)),
      mergeMap(r => {
        if (showLoader) {
          this._loader.hide();
        }
        return of(r);
      }),
      catchError(e => {
        if (showLoader) {
          this._loader.hide();
        }
        return throwError(e);
      }),
    );
  }
  patch(url: string, payload: any, showLoader: boolean = true): Observable<any> {
    if (showLoader) {
      this._loader.show();
    }
    console.log(`PATCH (${showLoader}): ${this.url}${url}`);
    return this.buildHeaders().pipe(
      mergeMap(header => this._http.patch(this.url + url, payload, header)),
      mergeMap(r => {
        if (showLoader) {
          this._loader.hide();
        }
        return of(r);
      }),
      catchError(e => {
        if (showLoader) {
          this._loader.hide();
        }
        return throwError(e);
      }),
    );
  }
  put(url: string, payload: any, showLoader: boolean = true): Observable<any> {
    if (showLoader) {
      this._loader.show();
    }
    console.log(`PUT (${showLoader}): ${this.url}${url}`);
    return this.buildHeaders().pipe(
      mergeMap(header => this._http.put(this.url + url, payload, header)),
      mergeMap(r => {
        if (showLoader) {
          this._loader.hide();
        }
        return of(r);
      }),
      catchError(e => {
        if (showLoader) {
          this._loader.hide();
        }
        return throwError(e);
      }),
    );
  }
  delete(url: string, showLoader: boolean = true): Observable<any | void> {
    if (showLoader) {
      this._loader.show();
    }
    console.log(`DELETE (${showLoader}): ${this.url}${url}`);
    return this.buildHeaders().pipe(
      mergeMap(header => this._http.delete(this.url + url, header)),
      mergeMap(r => {
        if (showLoader) {
          this._loader.hide();
        }
        return of(r);
      }),
      catchError(e => {
        if (showLoader) {
          this._loader.hide();
        }
        return throwError(e);
      }),
    );
  }
  public async error(body: any): Promise<void> {
    const alert = await this._alert.create({
      // cssClass: 'my-custom-class',
      header: 'Error',
      message: body,
      buttons: ['OK'],
    });
    await alert.present();
  }
  protected getUrl(): void {
    this.url = environment.apiUrl;
  }
  protected buildHeaders(headers?: HttpHeaders): Observable<any> {
    return from(this._storage.get('jwt')).pipe(mergeMap((jwt: any) => {
      const httpOptions = headers ? {headers} : {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'jwt': jwt || 'no-jwt',
        }),
      };
      return of(httpOptions);
    }));
  }
}
